<template>
  <div
    :class="[
      bem.e('pagination-box'),
      props.alignment === 'left' && bem.m('left'),
      props.alignment === 'center' && bem.m('center'),
      props.alignment === 'right' && bem.m('right'),
    ]"
  >
    <a-pagination
      v-bind="attrs"
      :size="size"
      :class="`${bem.e('pagination')}`"
      :current="props.current"
      :page-size="localPageSize"
      :total="props.total"
      :show-size-changer="!simple"
      :show-total="(total: number) => `共 ${total} 条`"
      @change="handlePageChange"
    />
    <div v-if="!props.simple" :class="[bem.e('pagination-quick-jump')]">
      跳至
      <a-input-number
        v-model:value="current"
        :disabled="max <= 1"
        :class="[bem.e('pagination-input')]"
        :size="size"
        :precision="0"
        :controls="false"
        @blur="handleNumberChange"
        @press-enter="handleNumberChange"
      />
      页
    </div>

    <!-- :show-total="(total: number) => `共 ${total} 条`" -->
    <!-- :show-total="(total, range) => showTotal?.(total, range)" -->
    <!-- <a-pagination
      v-bind="attrs"
      :class="`${bem.e('pagination')}`"
      :current="props.current"
      :page-size="props.pageSize"
      :total="props.total"
      show-size-changer
      show-quick-jumper
      :show-total="(total, range) => showTotal?.(total, range)"
      @change="handlePageChange"
    /> -->
  </div>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { computed, ref, useAttrs } from 'vue'
import { tablePaginationProps } from '../config'

// 1.defineOptions
defineOptions({ name: 'LlPagination' })

// 2.props
const props = defineProps(tablePaginationProps)

// 3.hooks
const attrs = useAttrs()

// 4.const
const bem = createNamespace('table')

const current = ref<number | undefined>(undefined)

const max = computed(() => Math.ceil(props.total! / props.pageSize!))

// 添加pageSize的计算属性，确保数据能及时变更
const localPageSize = computed({
  get() {
    return props.pageSize
  },
  set(newVal) {
    // 可以在这里添加额外的校验逻辑
    if (props.onChange) {
      props.onChange(props.current || 1, newVal)
    }
  },
})

// 5.methods
const handlePageChange = (page: number, pageSize: number) =>
  props.onChange && props.onChange(page, pageSize)

const handleNumberChange = () => {
  if (current.value === undefined) return
  if (current.value < 1) {
    current.value = 1
  } else if (current.value > max.value) {
    current.value = max.value
  }
  handlePageChange(current.value, props.pageSize!)
  current.value = undefined
}
</script>
